import RuleEditor from "./RuleEditor";

export default function RuleCreatePage() {
  return <RuleEditor mode="create" />;
}